// FILES USED in other places too
/*
    '/':'Home',
    '/eligibility':'Eligibility',
    '/coverage-periods-rates':'Coverage Rates',
    '/plan-details':'Plan Details',
    '/care':'Access Care',
    '/Contacts':'Contacts'


*/
const CODES = {
  EXT_CLICK:'EXT_CLICK' ,
  HOME_CLICK:'HOME_CLICK' ,
  HOME_PAGE_OPEN:'HOME_PAGE_OPEN',
  COV_PER_RATE:'COV_PER_RATE',
  PLAN_DETAIL_CLICK:'PLAN_DETAIL_CLICK',
  CARE_OPEN:'CARE_OPEN',
  FOOT_PP_LINK:'FOOT_PP_LINK',
  FOOT_LEGAL_LINK:'FOOT_LEGAL_LINK',
  HEADER_SITE_VISIT:'HEADER_SITE_VISIT',
  BROKER_LINK:'BROKER_LINK',
  ANTHEM_SITE:'ANTHEM_SITE',
  MORE_ENROLL_MAT:"MORE_ENROLL_MAT",
  Coverage_Rates:"Coverage_Rates",
  Eligibility:"Eligibility",
  Plan_Details:'Plan_Details',
  Access_Care:'Access_Care',
  Contacts:'Contacts'
  
};
  
CODES.NAMES = {
  Contacts:'Contacts',
  Plan_Details:'Plan Details',
  Coverage_Rates:'Coverage Rates',
  Eligibility:'Eligibility',
  Access_Care:'Access Care',
  EXT_CLICK: 'Embedded Link',
  HOME_CLICK: 'Home button click',
  COV_PER_RATE:'Coverage periods and rates open',
  PLAN_DETAIL_CLICK:'Your plan details open',
  CARE_OPEN:'Where to go for care open',
  FOOT_PP_LINK:'Footer Privacy Policy Link',
  FOOT_LEGAL_LINK:"Footer Legal link",
  HEADER_SITE_VISIT:"Header Logo click",
  BROKER_LINK:"Broker Link",
  ANTHEM_SITE:"Anthem Site",
  HOME_PAGE_OPEN:"Home Page open",
  MORE_ENROLL_MAT:'More enrollment material link'
  
};
  
CODES.GROUPS = [];
CODES.GROUPS['Coverage_Rates'] = [CODES.Coverage_Rates];
CODES.GROUPS['Plan Details'] = [CODES.Plan_Details];
CODES.GROUPS['Access Care'] = [CODES.Access_Care];
CODES.GROUPS['Eligibility'] = [CODES.Eligibility];
CODES.GROUPS['Contacts'] = [CODES.Contacts];

  
CODES.belongsToGroup = (act, k) => {
  if (CODES.GROUPS[k].indexOf(act) != -1) {
    return true;
  }
  
  return false;
};
  
CODES.TEMP = [];
  
CODES.ENGAGEMENT = [
  
];
  
CODES.getReadableName = (pcode) => {
  try {
    return CODES.NAMES[pcode];
  } catch (err) {
    return 'ERR on Name';
  }
};
  
CODES.getGroupTotal = (sorted, code) => {
  let total = 0;
  _.each(sorted, (a) => {
    if (a.act.indexOf(code) != -1) {
      if (a.count > 0) {
        total += a.count;
      }
    }
  });
  return total;
};
  
export default CODES;
  